<template>
  <TheLayout>
    <div
      v-if="dataPermission && dataPermission.includes('NSH_ITEM_CATEG_VIEW')"
    >
      <div class="row px-3 d-flex justify-content-between">
        <div class="page-title title">
          <span>QUẢN LÝ DANH MỤC</span>
        </div>
      </div>
      <div class="main-content-layout mt-3">
        <div class="d-fex justify-content=between mb-3">
          <b-input-group class="wrapperInput d-flex justify-content-between">
            <el-input
              v-model="textName"
              @keyup.native.enter="clickSearch"
              placeholder="Tìm kiếm theo tên sản phẩm, danh mục sản phẩm"
              prefix-icon="el-icon-search"
              style="width: 400px"
              clearable
            >
            </el-input>
            <el-button class="n-btn" type="primary" v-if="dataPermission && dataPermission.includes('NSH_ITEM_CATEG_CREATE')"
              @click="clickAddCategory">
              <div class="n-icon">
                  <i class="mdi mdi-plus"></i>
                Thêm mới danh mục
              </div>
            </el-button>
          </b-input-group>
        </div>
        <div class="row mb-3" v-if="listCheckBox.length > 1">
          <div class="col-md-12">
            <span class="mt-2 d-inline mr-2"
              >Đã chọn {{ listCheckBox.length }} danh mục</span
            >
            <!-- <el-button v-if="
              dataPermission &&
              dataPermission.includes('NSH_ITEM_CATEG_DELETE') &&
              this.listCheckBox.length > 0
              " @click="removeListItem()" type="danger" plain>Xóa danh mục
            </el-button> -->
            <el-button  v-if="
              dataPermission &&
              dataPermission.includes('NSH_ITEM_CATEG_DELETE') &&
              this.listCheckBox.length > 0
            " @click="removeListItem()" class="n-btn" type="danger" plain>Xóa danh mục</el-button>
          </div>
        </div>

        <div class="col-lg-12 p-0">
          <div class="card">
            <div class="card-body" v-loading="loading">
              <div
                class="groupCategory col-lg-12 pr-0"
                v-for="(item, index) in category"
                :key="index"
              >
                <div
                  v-if="category.length === 0"
                  class="d-flex"
                  style="
                    justify-content: center;
                    font-size: 14px;
                    font-weight: bold;
                    color: #afadad;
                  "
                >
                  Chưa có dữ liệu danh mục
                </div>
                <div class="group-head d-flex col-lg-12 pb-2 pl-0">
                  <div class="col-lg-6 pl-0">
                    <label class="group-item">
                      <input
                        type="checkbox"
                        @change="checkBox(item, $event)"
                        v-model="item.checkbox"
                        :disabled="item.objectClass == 'NSH_ROOT_CATEGORY'"
                      />
                      {{ item.name }}
                    </label>
                  </div>
                  <div class="actionCate col-lg-6">
                    <span
                      class="colorPri pl-3"
                      @click="editItem(item)"
                      v-if="
                        dataPermission &&
                        dataPermission.includes(
                          'NSH_ITEM_CATEG_UPDATE'
                        ) &&
                        item.objectClass !== 'NSH_ROOT_CATEGORY'
                      "
                    >
                      Chỉnh sửa
                    </span>
                    <span
                      class="colorDanger pl-3"
                      @click="deleteItem(item)"
                      v-if="
                        dataPermission &&
                        dataPermission.includes(
                          'NSH_ITEM_CATEG_DELETE'
                        ) &&
                        item.objectClass !== 'NSH_ROOT_CATEGORY'
                      "
                    >
                      Xóa
                    </span>
                  </div>
                </div>
                <div class="head">
                  <div
                    class="col-lg-12 pl-0"
                    v-for="subItem in item.sub"
                    :key="subItem.id"
                  >
                    <div class="col-lg-12 d-flex pr-0 pl-0">
                      <div class="col-lg-6">
                        <label class="item-one">
                          <input
                            class="item-check"
                            type="checkbox"
                            @change="
                              checkBoxProduct(subItem, item, index)
                            "
                            :checked="isChecked(subItem.id)"
                            :disabled="item.objectClass == 'NSH_ROOT_CATEGORY'"
                          />
                          <span class="item-name">{{
                            subItem.name
                          }}</span>
                        </label>
                      </div>
                      <div class="actionCate col-lg-6">
                        <span
                          class="colorPri pl-3"
                          @click="editProduct(subItem)"
                          v-if="
                            dataPermission &&
                            dataPermission.includes(
                              'NSH_ITEM_TYPE_UPDATE'
                            ) && subItem.objectClass !== 'NSH_ROOT_CATEGORY'
                          "
                        >
                          Chỉnh sửa
                        </span>
                        <span
                          class="colorDanger pl-3"
                          @click="deleteItemProd(subItem)"
                          v-if="
                            dataPermission &&
                            dataPermission.includes(
                              'NSH_ITEM_TYPE_DELETE'
                            ) && subItem.objectClass !== 'NSH_ROOT_CATEGORY'
                          "
                        >
                          Xóa
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="col-lg-12">
                      <div
                        class="col-lg-6"
                        @click="clickAddProduct(item)"
                      >
                        <span
                          class="colorPri"
                          v-if="
                            dataPermission &&
                            dataPermission.includes(
                              'NSH_ITEM_TYPE_CREATE'
                            )
                          "
                        >
                          + Thêm loại sản phẩm
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-modal ok-only v-model="showMsg">
            Danh mục hiện tại đang chứa loại sản phẩm. Vui lòng xóa các dữ
            liệu bên trong đó
          </b-modal>
        </div>

        <!-- <div class="box-loading" v-if="loading">
          <div class="loading">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </div> -->
        <!-- Modal 1 -->
        <el-dialog :before-close="hideModal" custom-class="n-modal" title="Xóa danh mục ?" width="600px" :visible.sync="showModalDelete">
          <div class="text-center">
            <div class="image" style="height: 120px">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="mt-3">Xác nhận hủy bỏ "{{ dataDeleted.name }}" này!</div>
          </div>
          <div slot="footer">
            <el-button class="n-btn" @click="confirmDeleteItem" plain type="danger">Xác Nhận</el-button>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalDelete"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">Xóa danh mục ?</div>
              <div class="text-des-modal text-danger">
                Xác nhận hủy bỏ "{{ dataDeleted.name }}" này!
              </div>
            </div>
          </div>
          <b-button @click="confirmDeleteItem" class="btn btn-danger btn-block"
            >Xác nhận</b-button
          >
        </b-modal> -->
        <!-- Modal 2 -->
        <el-dialog :before-close="hideModal" custom-class="n-modal" title="Xóa danh mục ?" width="600px" :visible.sync="showModalDeleteMore">
          <div class="text-center">
            <div class="image" style="height: 120px">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="mt-3">Xác nhận hủy bỏ những danh mục này</div>
          </div>
          <div slot="footer">
            <el-button class="n-btn" @click="confirmDeleteItemMore" plain type="danger">Xác Nhận</el-button>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalDeleteMore"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">Xóa danh mục ?</div>
              <div class="text-des-modal text-danger">
                Xác nhận hủy bỏ những danh mục này
              </div>
            </div>
          </div>
          <b-button
            @click="confirmDeleteItemMore"
            class="btn btn-danger btn-block"
            >Xác nhận</b-button
          >
        </b-modal> -->
        <!-- Modal 3 -->
        <b-modal
          v-model="showModalDeletAlert"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/alert.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal">Xóa danh mục ?</div>
              <div class="text-des-modal">
                Vui lòng chọn nhiều danh mục để xóa
              </div>
            </div>
          </div>
          <b-button @click="hideModal" class="btn btn btn-danger btn-block"
            >Chọn lại</b-button
          >
        </b-modal>
        <!-- Modal 4 -->
        <!-- popup -->
        <el-dialog custom-class="n-modal" title="Sửa danh mục sản phẩm" width="600px" :visible.sync="showModalEdit" :before-close="destroyModalEdit">
          <!-- body -->
          <div class="box-modal">
            <label>Tên danh mục <span class="color-red">*</span></label>
            <input
              type="text"
              class="form-control"
              v-model="dataEdit.name"
              :class="{ error: isErrorEdit1 || isErrorEdit2 }"
            />
            <div
              class="showError"
              v-if="isErrorEdit1"
              style="color: red; font-size: 12px"
            >
              Tên danh mục không được để trống, vui lòng điền thông tin để hoàn
              tất
            </div>
            <div
              class="showError"
              v-if="isErrorEdit2"
              style="color: red; font-size: 12px"
            >
              Vui lòng nhập không quá 255 ký tự
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                v-model="dataEdit.desc"
                class="form-control"
                rows="5"
              ></textarea>
            </div>
          </div>

          <div slot="footer" class="d-flex justify-content-between">
            <el-button class="n-btn" @click="deleteItem(dataEdit)" type="danger">Xóa</el-button>
            <div>
              <el-button class="n-btn ml-auto" @click="destroyModalEdit">Thoát</el-button>
              <el-button class="n-btn" @click="confirmEdit" type="primary">Lưu</el-button>
            </div>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalEdit"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="destroyModalEdit"
          >
            ×
          </button>
          <div class="text-title-modal mb-3">Sửa danh mục sản phẩm</div>
          <div class="box-modal">
            <label>Tên danh mục <span class="color-red">*</span></label>
            <input
              type="text"
              class="form-control"
              v-model="dataEdit.name"
              :class="{ error: isErrorEdit1 || isErrorEdit2 }"
            />
            <div
              class="showError"
              v-if="isErrorEdit1"
              style="color: red; font-size: 12px"
            >
              Tên danh mục không được để trống, vui lòng điền thông tin để hoàn
              tất
            </div>
            <div
              class="showError"
              v-if="isErrorEdit2"
              style="color: red; font-size: 12px"
            >
              Vui lòng nhập không quá 255 ký tự
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                v-model="dataEdit.desc"
                class="form-control"
                rows="5"
              ></textarea>
            </div>
          </div>
          <div class="mt-2 text-right">
            <b-button
              @click="deleteItem(dataEdit)"
              class="btn btn-danger color-white float-left"
              >Xóa
            </b-button>
            <b-button
              @click="destroyModalEdit"
              class="btn btn-white color-default"
              >Thoát
            </b-button>
            <b-button
              @click="confirmEdit"
              class="btn btn-primary btn-primary-ext"
              type="submit"
              >Lưu
            </b-button>
          </div>
        </b-modal> -->
        <!-- Modal 5 -->
        <b-modal
          v-model="showModalDestroyEditCategory"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModalEdit"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/alert.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">Thoát sửa</div>
              <div class="text-des-modal text-danger">
                Khi bạn thoát mọi dữ liệu sẽ không được lưu!
              </div>
            </div>
          </div>
          <b-button
            @click="hideModal"
            class="btn btn-primary btn-primary-ext btn-block btn-danger"
            >Xác nhận</b-button
          >
        </b-modal>
        <!-- Modal 6 -->
        <!-- popup -->
        <el-dialog :before-close="destroyModal" custom-class="n-modal" title="Thêm mới danh mục sản phẩm" width="600px" :visible.sync="showModalAddCategory">
          <!-- body -->
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên danh mục <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataAdd.name"
                :class="{ error: isErrorAdd1 || isErrorAdd2 || isErrorAdd3 }"
              />
              <div
                class="showError"
                v-if="isErrorAdd1"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được để trống, vui lòng điền thông tin để
                hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorAdd2"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được quá 255 ký tự
              </div>
              <div
                class="showError"
                v-if="isErrorAdd3"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được chứa thẻ html
              </div>
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataAdd.description"
              ></textarea>
            </div>
          </div>

          <div slot="footer">
            <el-button class="n-btn" @click="destroyModal">Hủy</el-button>
            <el-button class="n-btn" @click="confirmAddCatId" type="primary">Hoàn tất</el-button>
          </div>
        </el-dialog>
        <!-- <b-modal
          v-model="showModalAddCategory"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="destroyModal"
          >
            ×
          </button>
          <div class="text-title-modal mb-3">Thêm mới danh mục sản phẩm</div>
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên danh mục <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataAdd.name"
                :class="{ error: isErrorAdd1 || isErrorAdd2 || isErrorAdd3 }"
              />
              <div
                class="showError"
                v-if="isErrorAdd1"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được để trống, vui lòng điền thông tin để
                hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorAdd2"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được quá 255 ký tự
              </div>
              <div
                class="showError"
                v-if="isErrorAdd3"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được chứa thẻ html
              </div>
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataAdd.description"
              ></textarea>
            </div>
          </div>
          <div class="mt-2 text-right">
            <b-button @click="destroyModal" class="btn btn-white color-default"
              >Hủy</b-button
            >
            <b-button
              @click="confirmAddCatId"
              class="btn btn-primary btn-primary-ext"
              >Hoàn tất</b-button
            >
          </div>
        </b-modal> -->
        <!-- Modal 7 -->
        <b-modal
          v-model="showModalAddCategoryOk"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/icon-success.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal">Thêm mới danh mục</div>
              <div class="text-des-modal">
                Thêm mới danh mục sản phẩm thành công!
              </div>
            </div>
          </div>
          <b-button
            @click="hideModal"
            class="btn btn-primary btn-primary-ext btn-block"
            >Tiếp tục</b-button
          >
        </b-modal>
        <!-- Modal 8 -->
        <b-modal
          v-model="showModalDestroyAddCategory"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModalAdd"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/alert.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">Hủy tạo mới</div>
              <div class="text-des-modal text-danger">
                Xác nhận hủy tạo
                {{ dataAdd.name ? `"${dataAdd.name}"` : "" }} mới!
              </div>
            </div>
          </div>
          <b-button
            @click="hideModal"
            class="btn btn-primary btn-primary-ext btn-block btn-danger"
            >Xác nhận</b-button
          >
        </b-modal>
        <!-- --- Modal add product --- -->
        <el-dialog :before-close="hideModal" custom-class="n-modal" title="Thêm mới loại sản phẩm" width="600px" :visible.sync="showModalAddProduct">
          <!-- body -->
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên loại sản phẩm <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataAdd.name"
                :class="{ error: isErrorAdd1 || isErrorAdd2 || isErrorAdd3 }"
              />
              <div
                class="showError"
                v-if="isErrorAdd1"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được để trống, vui lòng điền thông tin
                để hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorAdd2"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được quá 255 ký tự
              </div>
              <div
                class="showError"
                v-if="isErrorAdd3"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được chứa thẻ html
              </div>
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataAdd.description"
              ></textarea>
            </div>
          </div>

          <div slot="footer">
            <el-button class="n-btn" @click="destroyModal">Hủy</el-button>
            <el-button class="n-btn" @click="confirmAddCatId" type="primary">Hoàn tất</el-button>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalAddProduct"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="text-title-modal mb-3">Thêm mới loại sản phẩm</div>
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên loại sản phẩm <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataAdd.name"
                :class="{ error: isErrorAdd1 || isErrorAdd2 || isErrorAdd3 }"
              />
              <div
                class="showError"
                v-if="isErrorAdd1"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được để trống, vui lòng điền thông tin
                để hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorAdd2"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được quá 255 ký tự
              </div>
              <div
                class="showError"
                v-if="isErrorAdd3"
                style="color: red; font-size: 12px"
              >
                Tên danh mục không được chứa thẻ html
              </div>
            </div>
            <div class="mt-2">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataAdd.description"
              ></textarea>
            </div>
          </div>
          <div class="mt-2 text-right">
            <b-button @click="destroyModal" class="btn btn-white color-default"
              >Hủy</b-button
            >
            <b-button
              @click="confirmAddCatId"
              class="btn btn-primary btn-primary-ext"
              >Hoàn tất</b-button
            >
          </div>
        </b-modal> -->
        <!-- --- Modal edit product--- -->
        <!-- popup -->
        <el-dialog :before-close="hideModal" custom-class="n-modal" title="Cập nhật loại sản phẩm" width="600px" :visible.sync="showModalEditProduct">
          <!-- body -->
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên loại sản phẩm <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataEdit.name"
                :class="{ error: isErrorEdit1 || isErrorEdit2 }"
              />
              <div
                class="showError"
                v-if="isErrorEdit1"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được để trống, vui lòng điền thông tin
                để hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorEdit2"
                style="color: red; font-size: 12px"
              >
                Vui lòng viết tên loại sản phẩm không được quá 255 ký tự
              </div>
            </div>
            <div class="mt-2 blx">
              <label
                >Thuộc danh mục sản phẩm <span class="color-red">*</span></label
              >
              <b-form-select
                v-model="dataEdit.parentId"
                :options="dataCateParentExt"
                :class="{ error: isErrorCatId }"
              ></b-form-select>
              <div
                class="showError"
                v-if="isErrorCatId"
                style="color: red; font-size: 12px"
              >
                Chưa chọn danh mục sản phẩm
              </div>
            </div>
            <div class="mt-2 blx">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataEdit.desc"
              ></textarea>
            </div>
          </div>

          <div slot="footer" >
            <div class="d-flex justify-content-between">
              <el-button class="n-btn" @click="deleteItem(dataEdit)" type="danger">Xóa</el-button>
              <div>
                <el-button class="n-btn" @click="hideModal">Thoát</el-button>
                <el-button class="n-btn" @click="confirmEditProduct" type="primary">Lưu</el-button>
              </div>
            </div>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalEditProduct"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="text-title-modal mb-3">Cập nhật loại sản phẩm</div>
          <div class="box-modal">
            <div class="mt-2">
              <label>Tên loại sản phẩm <span class="color-red">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="dataEdit.name"
                :class="{ error: isErrorEdit1 || isErrorEdit2 }"
              />
              <div
                class="showError"
                v-if="isErrorEdit1"
                style="color: red; font-size: 12px"
              >
                Tên loại sản phẩm không được để trống, vui lòng điền thông tin
                để hoàn tất
              </div>
              <div
                class="showError"
                v-if="isErrorEdit2"
                style="color: red; font-size: 12px"
              >
                Vui lòng viết tên loại sản phẩm không được quá 255 ký tự
              </div>
            </div>
            <div class="mt-2 blx">
              <label
                >Thuộc danh mục sản phẩm <span class="color-red">*</span></label
              >
              <b-form-select
                v-model="dataEdit.parentId"
                :options="dataCateParentExt"
                :class="{ error: isErrorCatId }"
              ></b-form-select>
              <div
                class="showError"
                v-if="isErrorCatId"
                style="color: red; font-size: 12px"
              >
                Chưa chọn danh mục sản phẩm
              </div>
            </div>
            <div class="mt-2 blx">
              <label>Ghi chú</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="dataEdit.desc"
              ></textarea>
            </div>
          </div>
          <div class="mt-2 text-right">
            <b-button
              @click="deleteItem(dataEdit)"
              class="btn btn-danger color-white float-left"
              >Xóa</b-button
            >
            <b-button @click="hideModal" class="btn btn-white color-default"
              >Thoát</b-button
            >
            <b-button
              @click="confirmEditProduct"
              class="btn btn-primary btn-primary-ext"
              >Lưu</b-button
            >
          </div>
        </b-modal> -->

        <!--------------MODAL XÓA LOẠI SẢN PHẨM------------->
        <el-dialog :before-close="hideModal" custom-class="n-modal" title="Xóa loại sản phẩm ?" width="600px" :visible.sync="showModalDeleteProd">
          <div class="text-center">
            <div class="image" style="height: 120px">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="mt-3">Xác nhận hủy bỏ "{{ dataDeleted.name }}" này!</div>
          </div>
          <div slot="footer">
            <el-button class="n-btn" @click="confirmDeleteItem" plain type="danger">Xác Nhận</el-button>
          </div>
        </el-dialog>

        <!-- <b-modal
          v-model="showModalDeleteProd"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="hideModal"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">
                Xóa loại sản phẩm ?
              </div>
              <div class="text-des-modal text-danger">
                Xác nhận hủy bỏ "{{ dataDeleted.name }}" này!
              </div>
            </div>
          </div>
          <b-button @click="confirmDeleteItem" class="btn btn-danger btn-block"
            >Xác nhận</b-button
          >
        </b-modal> -->

        <!-- <b-modal
          v-model="showModalDeleteMore"
          hide-header
          hide-footer
          no-close-on-backdrop
          class="modalDialog"
        >
          <button
            type="button"
            aria-label="Close"
            class="close close-ext"
            @click="showModalDeleteMore = false"
          >
            ×
          </button>
          <div class="box-modal">
            <div class="box-left-modal w-100 text-center">
              <img src="@/assets/images/icon-remove.png" />
            </div>
            <div class="box-right-modal w-100 text-center">
              <div class="text-title-modal text-danger">
                Xóa loại sản phẩm ?
              </div>
              <div class="text-des-modal text-danger">
                Xác nhận hủy bỏ những loại sản phẩm này!
              </div>
            </div>
          </div>
          <b-button
            @click="confirmDeleteItemMore"
            class="btn btn-danger btn-block"
            >Xác nhận</b-button
          >
        </b-modal> -->
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import { CategoryService } from "@/services/nextshop/category.service";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  created() {
    this.listCategory();
    this.isChecked();
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      submitform: false,
      current_page: 1,
      total_rows: 0,
      total_category: 200,
      per_page: 50,
      total_len: 0,
      search: {
        queryString: {},
        sort: "-id",
        lastItem: "",
        limit: 20,
      },
      textName: "",
      checkSearch: false,

      loadingSearchCategory: false,

      storeLastIndex: [],
      optionsPerPage: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],

      selected: [],
      checkAll: [],
      dataCate: [],
      dataCateShow: [],
      listCheckBox: [],
      countDataCateTotal: 0,
      loading: true,

      showModalDelete: false,
      showModalDeleteMore: false,
      showModalDeleteOk: false,
      showModalDeleteProd: false,
      showModalAddProduct: false,
      dataDeleted: {},
      showModalDeletAlert: false,
      showModalEditProduct: false,

      showModalEdit: false,
      showModalEditOk: false,
      isErrorCatId: false,
      showModalDestroyEditCategory: false,
      dataEdit: { name: null },
      dataEditCheck: { name: null },

      dataEditCate: {},
      dataAddProduct: {},

      isError: false,
      isErrorAdd1: false,
      isErrorAdd2: false,
      isErrorAdd3: false,
      isErrorEdit1: false,
      isErrorEdit2: false,

      showModalAddCategory: false,
      showModalAddCategoryOk: false,
      showModalDestroyAddCategory: false,
      showMsg: false,

      dataCateParentId: [],
      cap2List: [],
      dataAdd: {
        name: "",
        description: "",
        imageUrl: "",
        parentId: "",
      },
      category: [],
      dataCateParentExt: [],
      dataProductCheck: [],
      searchCategory: {
        queryString: { parentId: { eq: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      },
      searchSub: {
        queryString: { parentId: { ne: "" } },
        sort: "-id",
        lastItem: "",
        limit: 50,
      },
    };
  },
  watch: {
    textName: {
      handler: function () {
        if (this.textName == "") this.remove();
      },
    },
  },
  methods: {
    //xoa text trong o tim kiem
    msgSuccessAddCategory() {
      Swal.fire({
        icon: "success",
        title:
          '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
        html: `<span style="color:#9093A4; font-size: 14px;" > Thêm mới danh mục sản phẩm thành công!</span>`,
        confirmButtonText: "Xác nhận",
      });
    },
    msgSuccessDeleteOk() {
      Swal.fire({
        icon: "success",
        title:
          '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
        html: `<span style="color:#9093A4; font-size: 14px;" > Xóa thành công!</span>`,
        confirmButtonText: "Xác nhận",
      });
    },
    remove() {
      this.textName = "";
      this.searchCategory = {
        queryString: { parentId: { eq: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      };
      this.searchSub = {
        queryString: { parentId: { ne: "" } },
        sort: "-id",
        lastItem: "",
        limit: 50,
      };
      this.listCategory();
    },

    async countGetList() {
      try {
        this.loading = true;

        this.search.queryString = { parentId: { eq: "" } };
        if (this.textName != "") {
          this.search.queryString = {
            parentId: { eq: "" },
            name: { eq: this.textName.trim() },
          };
        }

        const response = await CategoryService.countGetList(this.search);

        if (response.success) {
          this.countDataCateTotal = response.data.count;
          this.total_rows = response.data.count;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async clickSearch() {
      await this.listCategory();
      await this.countGetList();
      this.checkSearch = true;
    },
    async hideModal() {
      this.showModalDelete = false;
      this.showModalDeleteMore = false;
      this.showModalDeleteOk = false;
      this.showModalDeletAlert = false;
      this.showModalDeleteProd = false;
      this.showModalAddProduct = false;
      this.showModalEditProduct = false;

      this.showModalEdit = false;
      this.showModalEditOk = false;
      this.showModalDestroyEditCategory = false;

      this.showModalAddCategory = false;
      this.showModalAddCategoryOk = false;
      this.showModalDestroyAddCategory = false;

      this.isErrorAdd1 = false;
      this.isErrorAdd2 = false;
      this.isErrorCatId = false;
      this.isErrorAdd3 = false;
      this.isErrorEdit1 = false;
      this.isErrorEdit2 = false;

      (this.dataAdd.name = ""),
        (this.dataAdd.parentId = ""),
        (this.dataAdd.description = "");
    },
    async destroyModal() {
      if (this.dataAdd.name || this.dataAdd.description != "") {
        this.showModalDestroyAddCategory = true;
      } else {
        // this.showModalDestroyAddCategory = false;
        this.hideModal();
      }
      this.showModalAddCategory = false;
    },
    async hideModalAdd() {
      this.showModalAddCategory = true;
    },
    async destroyModalEdit() {
      if (
        this.dataEditCheck.name != this.dataEdit.name ||
        this.dataEditCheck.desc != this.dataEdit.desc
      ) {
        this.showModalDestroyEditCategory = true;
        this.showModalEdit = false;
      } else {
        this.showModalEdit = false;
        this.showModalDestroyEditCategory = false;
      }
    },
    async hideModalEdit() {
      if (
        this.dataEditCheck.name != this.dataEdit.name ||
        this.dataEditCheck.desc != this.dataEdit.desc
      ) {
        this.showModalEdit = true;
        this.showModalDestroyEditCategory = false;
      } else {
        this.showModalEdit = false;
        this.showModalDestroyEditCategory = false;
      }
    },
    async deleteItem(data) {
      try {
        const list = this.cap2List.filter((e) => e.parentId == data.id);
        if (list.length == 0) {
          this.showModalDelete = true;
          this.showModalEdit = false;
          this.showModalEditProduct = false;
          this.dataDeleted = data;
        } else {
          this.showMsg = true;
        }
        return false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteItemProd(data) {
      try {
        this.showModalDeleteProd = true;
        this.showModalEdit = false;
        this.dataDeleted = data;
        return false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async confirmDeleteItem() {
      try {
        this.showModalDelete = false;
        this.showModalDeleteProd = false;
        this.loading = true;
        const itemId = this.dataDeleted.id;
        const version = parseInt(this.dataDeleted.version);
        const _params = { optimisticVersion: version };
        const response = await CategoryService.deleteCate(itemId, _params);
        if (response.success) {
          await this.listCategory();
          await this.countGetList();
          this.msgSuccessDeleteOk();
          this.showModalEditOk = false;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async editItem(data) {
      this.showModalEdit = true;
      this.dataEdit = {
        name: data.name,
        desc: data.desc,
        id: data.id,
        version: data.version,
      };
      this.dataEditCheck = {
        name: data.name,
        desc: data.desc,
      };
    },

    async confirmEdit() {
      try {
        this.loading = true;
        if (this.dataEdit.name == null || this.dataEdit.name.trim() == "") {
          this.isErrorEdit1 = true;
          this.isErrorEdit2 = false;
          return false;
        } else if (this.dataEdit.name.trim().length > 255) {
          this.isErrorEdit2 = true;
          this.isErrorEdit1 = false;
        } else {
          this.showModalEdit = false;
          const itemId = this.dataEdit.id;
          if (itemId != "") {
            const version = parseInt(this.dataEdit.version);
            const _params = {
              name: this.dataEdit.name.trim(),
              description: this.dataEdit.desc,
              optimisticVersion: version,
            };

            const response = await CategoryService.updateCate(itemId, _params);
            if (response.success) {
              await this.listCategory();
              this.showModalEditOk = true;
              this.isErrorEdit1 = false;
              this.isErrorEdit2 = false;
              this.showModalDeleteOk = false;
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async confirmEditProduct() {
      try {
        this.loading = true;
        if (this.dataEdit.name == null || this.dataEdit.name.trim() == "") {
          this.isErrorEdit1 = true;
          this.isErrorEdit2 = false;
          return false;
        } else {
          this.isErrorEdit1 = false;
          this.isErrorEdit2 = false;
        }

        if (this.dataEdit.name.trim().length > 255) {
          this.isErrorEdit2 = true;
          this.isErrorEdit1 = false;
          return false;
        }

        if (this.dataEdit.parentId == "") {
          this.isErrorCatId = true;
          return false;
        } else {
          this.showModalEdit = false;
          this.dataEdit.name = this.dataEdit.name.trim();
          this.isErrorEdit2 = false;
          this.isErrorEdit1 = false;
          const itemId = this.dataEdit.id;
          if (itemId != "") {
            const version = parseInt(this.dataEdit.version);
            const _params = {
              name: this.dataEdit.name.trim(),
              description: this.dataEdit.desc,
              optimisticVersion: version,
            };

            const response = await CategoryService.updateCate(itemId, _params);
            if (response.success) {
              this.showModalEditProduct = false;
              const _params = {
                id: itemId,
                parentId: this.dataEdit.parentId,
                optimisticVersion: version + 1,
              };
              await CategoryService.changeParentCate(_params);

              await this.listCategory();
              this.showModalEditOk = true;
              this.isErrorEdit1 = false;
              this.isErrorEdit2 = false;
              this.showModalDeleteOk = false;
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async clickAddCategory() {
      this.showModalAddCategory = true;
    },
    // ---show modal add product---
    async clickAddProduct(data) {
      this.dataAddProduct = data;
      this.showModalAddProduct = true;
    },
    // ---- show modal edit product ---
    // checkbox
    checkBox(data) {
      if (data.checkbox) {
        this.listCheckBox.push(data.id);
        data.sub.map((e) => {
          this.listCheckBox.push(e.id);
        });
      }
      if (!data.checkbox) {
        const index = this.listCheckBox.indexOf(data.id);
        if (index > -1) {
          this.listCheckBox.splice(index, 1);
        }
        data.sub.map((e) => {
          const index = this.listCheckBox.indexOf(e.id);
          if (index > -1) {
            this.listCheckBox.splice(index, 1);
          }
        });
      }
    },

    isChecked(id) {
      return this.listCheckBox.includes(id);
    },
    // checkbox các sản phẩm thuộc danh mục
    checkBoxProduct(data, item, index) {
      const exists = this.listCheckBox.includes(data.id);
      if (exists) {
        this.listCheckBox = this.listCheckBox.filter((c) => {
          return c !== data.id;
        });
      } else {
        this.listCheckBox.push(data.id);
      }
      this.category[index].checkbox = item.sub.every((i) =>
        this.listCheckBox.includes(i.id)
      );
      if (this.category[index].checkbox) {
        this.listCheckBox.push(this.category[index].id);
      } else {
        const index = this.listCheckBox.indexOf(item.id);
        if (index > -1) {
          this.listCheckBox.splice(index, 1);
        }
      }
    },

    async editProduct(data) {
      this.showModalEditProduct = true;
      this.dataEdit = {
        name: data.name,
        desc: data.desc,
        parentId: data.parentId,
        version: data.version,
        id: data.id,
      };
      this.dataEditCheck = {
        name: data.name,
        desc: data.desc,
        parentId: data.parentId,
      };
    },
    async confirmAddCatId() {
      try {
        this.loading = true;
        if (this.dataAdd.name == null || this.dataAdd.name.trim() == "") {
          this.isErrorAdd1 = true;
          this.isErrorAdd2 = false;
          return false;
        } else if (this.dataAdd.name.trim().length > 255) {
          this.isErrorAdd2 = true;
          this.isErrorAdd1 = false;
          return false;
        } else if (this.checkAddName(this.dataAdd.name)) {
          this.isErrorAdd3 = true;
          this.isErrorAdd2 = false;
          this.isErrorAdd1 = false;
          return false;
        } else {
          if (this.dataAddProduct.id) {
            this.dataAdd.name = this.dataAdd.name.trim();
            this.dataAdd.parentId = this.dataAddProduct.id;
            this.isErrorAdd2 = false;
            this.isErrorAdd1 = false;
            this.isErrorAdd3 = false;
            const response = await CategoryService.addCate(this.dataAdd);
            if (response.success) {
              this.showModalAddCategory = false;
              await this.listCategory();
              await this.countGetList();
              this.dataAdd.name = "";
              this.dataAdd.description = "";
              this.dataAdd.parentId = "";
              this.dataAddProduct.id = "";
              this.showModalAddProduct = false;
              this.msgSuccessAddCategory();
              this.current_page = 1;
            }
          } else {
            this.dataAdd.name = this.dataAdd.name.trim();
            this.isErrorAdd2 = false;
            this.isErrorAdd1 = false;
            this.isErrorAdd3 = false;
            const response = await CategoryService.addCate(this.dataAdd);
            if (response.success) {
              this.showModalAddCategory = false;
              await this.listCategory();
              await this.countGetList();
              this.dataAdd.name = "";
              this.dataAdd.description = "";
              this.dataAdd.parentId = "";
              this.dataAddProduct.id = "";
              this.msgSuccessAddCategory();
              this.showModalAddCategory = false;
              this.current_page = 1;
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async changePerPage(per_page) {
      this.per_page = per_page;
      this.dataCate = [];
      this.dataCateShow = [];
      this.current_page = 1;
      this.storeLastIndex = [];
      this.getPageCategory("");
    },
    getFirstIndex() {
      if (this.total_len > 0) {
        return (this.current_page - 1) * this.per_page + 1;
      } else {
        return 0;
      }
    },
    getLastIndex() {
      if (this.total_len > 0) {
        if (this.total_len == this.per_page) {
          return this.current_page * this.per_page;
        } else {
          return this.countDataCateTotal;
        }
      } else {
        return 0;
      }
    },
    async previousPageCategory() {
      this.current_page--;
      if (this.current_page > 1) {
        this.getPageCategory(this.storeLastIndex[this.current_page - 2]);
      } else {
        this.current_page = 1;
        this.getPageCategory("");
      }
    },
    async nextPageCategory() {
      this.getPageCategory(this.storeLastIndex[this.current_page - 1]);
      this.current_page++;
    },
    async getPageCategory(lastItem) {
      try {
        this.loadingSearchCategory = true;
        this.search.limit = this.per_page;
        this.search.lastItem = lastItem;

        const response = await CategoryService.getList(this.search);
        // const response = await this.getList(this.headers, this.search);
        if (response.success) {
          if (response.data.length > 0) {
            const datas = [];
            moment.locale("vi");
            this.selected = [];
            this.checkAll = [];

            response.data.map((e) => {
              const body = {
                id: e.id,
                name: e.name,
                desc: e.description,
                createdAt: e.createdAt,
                parentId: e.parentId,
                version: e.version,
              };
              body.createdAt = moment(body.createdAt).format(
                "DD-MM-YYYY HH:mm"
              );
              datas.push(body);
            });
            this.dataCate = datas;
            this.dataCateShow = datas;
            let lastIndex = this.dataCateShow[this.dataCateShow.length - 1].id;
            if (!this.storeLastIndex.includes(lastIndex)) {
              this.storeLastIndex.push(lastIndex);
            }
          } else {
            this.dataCate = [];
            this.dataCateShow = [];
            // this.per_page = 0;
          }
          this.hideModal();
          this.total_len = this.dataCate.length;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingSearchCategory = false;
      }
    },

    async removeListItem() {
      if (this.listCheckBox.length > 0) {
        this.showModalDeleteMore = true;
      } else {
        this.showModalDeletAlert = true;
      }
    },
    async confirmDeleteItemMore() {
      try {
        this.loading = true;
        this.showModalDeleteMore = false;

        for (let i = 0; i < this.listCheckBox.length; i++) {
          const id = this.listCheckBox[i];
          const responseGetItem = await CategoryService.getItemIdCate(id);

          if (responseGetItem.success) {
            const version = parseInt(responseGetItem.data.version);
            const _params = { optimisticVersion: version };
            await CategoryService.deleteCate(id, _params);
          }
        }

        await this.listCategory();
        await this.countGetList();
        this.listCheckBox = [];
        this.checkAll = [];
        this.msgSuccessDeleteOk();
        this.showModalEditOk = false;
      } catch (error) {
        console.error(error);
        this.showModalEditOk = false;
        this.showModalDeleteMore = false;
        this.msgSuccessDeleteOk();
        await this.listCategory();
      } finally {
        // bug cũ chưa kịp xem, rảnh xem lại
        this.listCheckBox = [];
        this.loading = false;
      }
    },

    async checkItem(itemId) {
      if (this.selected.length != this.dataCate.length) {
        const checked = this.checkAll.includes(itemId);
        if (checked) {
          this.selected = this.checkAll.filter((t) => t !== itemId);
        } else {
          this.selected = this.checkAll.concat(itemId);
        }
        this.checkAll = this.selected;
      }
    },
    checkAddName(value) {
      let htmlRegex = new RegExp("<(\"[^\"]*\"|'[^']*'|[^'\">])*>");
      return htmlRegex.test(value);
    },

    // Get list Category - CategorySub
    async listCategory() {
      try {
        this.loading = true;

        if (this.textName != "") {
          this.searchCategory.queryString = {
            parentId: { eq: "" },
            name: { eq: this.textName.trim() },
          };
          this.searchSub.queryString = {
            parentId: { ne: "" },
            name: { eq: this.textName.trim() },
          };
        }
        const response = await CategoryService.getList(this.searchCategory);
        const res = await CategoryService.getList(this.searchSub);
        if (response.data) {
          const datas = [];
          response.data.map((e) => {
            let sub = [];
            const body = {
              id: e.id,
              name: e.name,
              version: e.version,
              desc: e.description,
              objectClass: e.objectClass,
            };
            res.data.map((e) => {
              if (e.parentId === body.id) {
                sub.push({
                  name: e.name,
                  id: e.id,
                  version: e.version,
                  desc: e.description,
                  parentId: e.parentId,
                  objectClass: e.objectClass,
                });
              }
            });
            body.sub = sub;
            datas.push(body);
          });
          const datasExt = [{ value: "", text: "Chọn danh mục sản phẩm" }];
          datas.map((e) => {
            const body = {
              value: e.id,
              text: e.name,
            };
            datasExt.push(body);
          });
          this.dataCateParentExt = datasExt;
          this.category = datas;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    selectAll: {
      get: function () {
        return this.dataCate.length
          ? this.selected.length === this.dataCate.length
          : false;
      },
      set: function (value) {
        const selected = [];
        if (value) {
          this.dataCate.forEach(function (val) {
            selected.push(val.id);
          });
          this.checkAll = selected;
        } else {
          if (this.selected.length === this.dataCate.length) {
            this.checkAll = [];
          }
        }
        this.selected = selected;
      },
    },
  },
};
</script>
<style lang="scss">
.search-input input{
  height: 44px;
  margin-top: 0
}
</style>
<style scoped>
.removeText {
  top: 25%;
}
.group-item[data-v-34bb222c] {
  font-size: 14px;
}
.groupCategory {
  border-bottom: 1px solid #e5e7e8;
  padding-bottom: 15px;
  margin-bottom: 12px;
}
.group-head .group-item {
  font-size: 14px;
  font-weight: bold;
}
.line-item {
  margin-top: 12px;
  display: inline-block;
  width: 100%;
  margin-left: 15px;
}

.item-one {
  font-size: 15px;
  font-weight: 400;
  margin: 2px 0;
  display: inline-block;
  width: 100%;
  height: 38px;
}

.groupCategory:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.item-check {
  display: inline-block;
  /* float: left; */
  vertical-align: top;
}

.item-name {
  display: inline-block;
  /* float: left; */
  width: 75%;
  vertical-align: top;
  margin-left: 8px;
  position: relative;
  top: -3px;
  font-size: 14px;
}
.actionCate {
  text-align: end;
}
.colorPri {
  color: #3e69f6;
  cursor: pointer;
}
.colorDanger {
  cursor: pointer;
  color: #dc2323;
}
.colorItem {
  cursor: pointer;
  color: #636678;
}
.card {
  border: 1px solid #dddddd;
  border-radius: 6px;
  color: #000000;
}
hr {
  border-top: 1px inset #e5e7e8;
}
</style>
